import { FaShieldAlt, FaLock, FaUserShield, FaDatabase, FaCookieBite, FaEnvelope } from 'react-icons/fa';
import styles from './Privacy.module.css';

const Privacy = () => {
  return (
    <section className={styles.privacySection}>
      <div className={styles.privacyContainer}>
        <div className={styles.privacyHeader}>
          <div className={styles.badge}>
            <FaShieldAlt className={styles.badgeIcon} />
            <span>Política de Privacidad</span>
          </div>
          <h1>Protegemos tu información personal</h1>
          <p>En LUCQA, nos comprometemos a proteger y respetar tu privacidad. Esta política explica cómo recopilamos, usamos y protegemos tu información.</p>
        </div>

        <div className={styles.contentGrid}>
          <div className={styles.contentCard}>
            <div className={styles.cardIcon}>
              <FaDatabase />
            </div>
            <h3>Información que Recopilamos</h3>
            <ul>
              <li>Información de contacto (nombre, email, teléfono)</li>
              <li>Información del proyecto y requisitos técnicos</li>
              <li>Datos de navegación y uso del sitio web</li>
              <li>Información proporcionada en formularios de contacto</li>
            </ul>
          </div>

          <div className={styles.contentCard}>
            <div className={styles.cardIcon}>
              <FaUserShield />
            </div>
            <h3>Cómo Usamos tu Información</h3>
            <ul>
              <li>Proporcionar y mejorar nuestros servicios</li>
              <li>Comunicarnos contigo sobre proyectos</li>
              <li>Enviar actualizaciones y información relevante</li>
              <li>Cumplir con obligaciones legales</li>
            </ul>
          </div>

          <div className={styles.contentCard}>
            <div className={styles.cardIcon}>
              <FaLock />
            </div>
            <h3>Protección de Datos</h3>
            <ul>
              <li>Encriptación de datos sensibles</li>
              <li>Acceso restringido a información personal</li>
              <li>Copias de seguridad regulares y seguras</li>
              <li>Cumplimiento con estándares de seguridad</li>
            </ul>
          </div>

          <div className={styles.contentCard}>
            <div className={styles.cardIcon}>
              <FaCookieBite />
            </div>
            <h3>Cookies y Tecnologías</h3>
            <ul>
              <li>Cookies esenciales para el funcionamiento del sitio</li>
              <li>Cookies analíticas para mejorar la experiencia</li>
              <li>Puedes gestionar las cookies en tu navegador</li>
              <li>No vendemos información a terceros</li>
            </ul>
          </div>
        </div>

        <div className={styles.rightsSection}>
          <h2>Tus Derechos</h2>
          <div className={styles.rightsList}>
            <div className={styles.rightItem}>
              <strong>Acceso:</strong> Puedes solicitar una copia de tu información personal.
            </div>
            <div className={styles.rightItem}>
              <strong>Rectificación:</strong> Puedes solicitar la corrección de información inexacta.
            </div>
            <div className={styles.rightItem}>
              <strong>Eliminación:</strong> Puedes solicitar la eliminación de tu información personal.
            </div>
            <div className={styles.rightItem}>
              <strong>Portabilidad:</strong> Puedes solicitar la transferencia de tus datos.
            </div>
          </div>
        </div>

        <div className={styles.contactSection}>
          <div className={styles.contactIcon}>
            <FaEnvelope />
          </div>
          <h3>¿Preguntas sobre Privacidad?</h3>
          <p>Si tienes alguna pregunta sobre esta política de privacidad o el manejo de tus datos, no dudes en contactarnos.</p>
          <a href="/presupuesto" className={styles.contactButton}>
            Contáctanos
          </a>
        </div>

        <div className={styles.updateInfo}>
          <p><strong>Última actualización:</strong> {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </div>
      </div>
    </section>
  );
};

export default Privacy;